import React from "react"
import NoContent from "components/elements/NoContent"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { VStack } from "@chakra-ui/react"
import { EVENT_WEBSITE_HELP_LINK } from "utilities/externalLinks"

type Props = {
  enableWebsite: () => void
  hasActiveSubscription: boolean
}

const NoWebsite = ({ enableWebsite, hasActiveSubscription }: Props) => {
  const descriptionItems = [
    "Publish a fully branded event website that brings together your key event details, content, agenda, speakers, and registration in one seamless experience.",
  ]

  const callsToActions = hasActiveSubscription
    ? [{
      text: "Set Up Page URL",
      action: enableWebsite,
      isButton: true,
    }, {
      icon: "book",
      text: "Learn more about Diobox Event Websites",
      link: EVENT_WEBSITE_HELP_LINK,
    }]
    : [{
      icon: "book",
      text: "Learn more about Diobox Event Websites",
      link: EVENT_WEBSITE_HELP_LINK,
    }]

  const footer = (
    <VStack w={600} align="center" spacing={0}>
      {!hasActiveSubscription && <UpgradeAlert text="This feature requires a subscription." continueOnTheCurrentScreen />}
    </VStack>
  )

  return (
    <>
      <NoContent
        title="Event Web Page"
        icon="globe"
        horizontalCTAs
        callsToActions={callsToActions}
        footer={footer}
        descriptionItems={descriptionItems}
      />
    </>
  )
}

export default NoWebsite
